<template>
  <v-app-bar app color="#F5F5F5" dense dark elevation="0">
    <v-app-bar-nav-icon
      class="d-md-none"
      @click.stop="changeMenu"
    ></v-app-bar-nav-icon>
    <!--  body-2      <v-toolbar-title class="body-2 mx-n4 blue-grey--text">{{getEmail}} delcio@kyamipay.ao</v-toolbar-title>-->
    <v-toolbar-title class="mx-n4 blue-grey--text m-size-font-12">{{
      getEmail
    }}</v-toolbar-title>
    <v-toolbar-title
      id="timerHelps"
      style="position: relative"
      class="blue-grey--text mx-6 m-size-font-12"
    >
      <count-down
        trans='{  
         "day":"Day",
         "hours":"Hours",
         "minutes":"Minuts",
         "seconds":"Seconds",
         "expired":"Sessão expirada.",
         "running":"",
         "upcoming":"",
         "status": {
            "expired":"Expired",
            "running":"Running",
            "upcoming":"Future"
           }}'
      ></count-down>
    </v-toolbar-title>
    <span>
      <v-badge tile content="Versão Beta" color="green"> </v-badge>
    </span>
    <v-spacer></v-spacer>
    <div>
      <v-list-item-avatar class="mx-n2" v-if="getOptMenu">
        <img
          :src="
            this.$store.getters.getAvatar
              ? 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/' +
                this.$store.getters.getAvatar
              : 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/public/user.png'
          "
          alt=""
        />
      </v-list-item-avatar>
      <v-list-item-avatar class="mx-n2" v-else>
        <img
          :src="
            this.$store.getters.getAvatarClient
              ? 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/' +
                this.$store.getters.getAvatarClient
              : 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/public/user.png'
          "
          alt=""
        />
      </v-list-item-avatar>
      <span class="mx-5 body-2  blue-grey--text">{{
        getOptMenu ? getOwnerFirstName : getFirstName
      }}</span>
    </div>
    <v-btn icon @click="callMessage">
      <v-icon color="blue-grey">mdi-account-question</v-icon>
    </v-btn>

    <v-menu left bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon color="blue-grey">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="() => {}">
          <v-list-item-avatar class="mx-n2" v-if="getOptMenu">
            <img
              :src="
                this.$store.getters.getAvatar
                  ? 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/' +
                    this.$store.getters.getAvatar
                  : 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/public/user.png'
              "
              alt=""
            />
          </v-list-item-avatar>
          <v-list-item-avatar class="mx-n2" v-else>
            <img
              :src="
                this.$store.getters.getAvatarClient
                  ? 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/' +
                    this.$store.getters.getAvatarClient
                  : 'https://kyami-assets.nyc3.cdn.digitaloceanspaces.com/public/user.png'
              "
              alt=""
            />
          </v-list-item-avatar>
          <!--          <v-list-item-title>{{ getUserName }}</v-list-item-title>-->
          <v-list-item-title class="mx-5">{{
            getOptMenu ? getOwnerFullName : getUserName
          }}</v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="RedirectToProfile">
          <v-list-item-title
            ><v-icon class="mr-4">mdi-account</v-icon>Perfil</v-list-item-title
          >
        </v-list-item>
        <v-list-item @click="Logout">
          <v-list-item-title
            ><v-icon class="mr-4">mdi-account-arrow-left-outline</v-icon
            >Terminar sessão</v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapHelper } from "@/store/helper";
import CountDown from "../tools/CountDown";
import { mapHelperEnterprise } from "@/store/helperEnterprise";
import eventBus from "../../main";

export default {
  name: "Menu",
  components: { CountDown },
  data() {
    return {
      mini: false,
      countDownDate: "",
      sec: ""
    };
  },
  methods: {
    Logout() {
      return this.setLogout;
    },
    callMessage() {
      eventBus.$emit("openMessageToSendEmail", true);
    },
    RedirectToProfile() {
      if (this.$store.getters.getOptMenu) {
        return this.$router.push("/e/profile");
      }
      this.$router.push("/account/profile");
    },
    changeMenu() {
      let c = (this.mini = !this.mini);
      eventBus.$emit("eventDrawClient", c);
    }
  },
  computed: {
    ...mapHelper,
    ...mapHelperEnterprise
  }
};
</script>

<style scoped></style>
